import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
export function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToTop} className={`fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full bg-white shadow-elevated border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:text-brand-blue hover:shadow-lg transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} aria-label="Back to top" data-id="element-554">
      <ArrowUpIcon className="w-5 h-5" data-id="element-555" />
    </button>;
}